module.exports = __webpack_public_path__ + "static/media/tinywow_2515Corylusavellana_colored_55475596.023b3344.jpg";